
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "introduction"
    }}>{`Introduction`}</h1>
    <p>{`VCC UI is a framework for building web applications and pages with `}<a parentName="p" {...{
        "href": "https://reactjs.org/"
      }}>{`React`}</a>{` that are fully compliant with the Volvo Cars Design System.`}</p>
    <h2 {...{
      "id": "whats-included"
    }}>{`What's Included?`}</h2>
    <ul>
      <li parentName="ul">{`Primitive core components (e.g. Block, Flex, Click, Text)`}</li>
      <li parentName="ul">{`Brand compliant UI components (e.g. Grid, Forms, Buttons, Navigation, Modals)`}</li>
      <li parentName="ul">{`Design System Tokens (e.g. colors, breakpoints, baseline grid)`}</li>
      <li parentName="ul">{`A powerful `}<a parentName="li" {...{
          "href": "/docs/css-in-js"
        }}>{`CSS-in-JS engine`}</a>{` and has everything you need to build an application from scratch to scale.`}</li>
    </ul>
    <h2 {...{
      "id": "why-use-it"
    }}>{`Why use it?`}</h2>
    <ul>
      <li parentName="ul">{`Lower the unnecessary cost of design differences and implementations across product teams`}</li>
      <li parentName="ul">{`Provide a consistent UX journey for customers and end-users`}</li>
      <li parentName="ul">{`Increase developer happiness and productivity`}</li>
      <li parentName="ul">{`Reduce time to market`}</li>
    </ul>
    <h2 {...{
      "id": "design-goals"
    }}>{`Design Goals`}</h2>
    <ul>
      <li parentName="ul">{`Components should be fully responsive and work on all supported viewports and devices`}</li>
      <li parentName="ul">{`Components should be able to render both server-side and client-side`}</li>
      <li parentName="ul">{`Components are built with accessibility, performance and SEO best practices in mind`}</li>
      <li parentName="ul">{`Components should be able to render in right to left languages (RTL)`}</li>
      <li parentName="ul">{`Provide an interface for i18n and localization`}</li>
      <li parentName="ul">{`Provide an interface for theming and branding`}</li>
      <li parentName="ul">{`Maintain a small footprint, and keep external dependencies to a minimum`}</li>
    </ul>
    <h2 {...{
      "id": "browser-support"
    }}>{`Browser support`}</h2>
    <ul>
      <li parentName="ul">{`Last 2 versions of Google Chrome`}</li>
      <li parentName="ul">{`Last 2 versions of iOS Safari`}</li>
      <li parentName="ul">{`Last 2 versions of macOS Safari`}</li>
      <li parentName="ul">{`Last 2 versions of MS Edge`}</li>
      <li parentName="ul">{`Latest version of desktop Firefox`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;